module.exports = __webpack_public_path__ + "static/media/watch-alt.74cd024d.svg";